"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import Toast from "vwa/components/Toast";
import dispatcher from "./../dispatcher";
import {getUserId} from "./../utils/user";

export default async function saveContacts(contacts) {
	try {
		const userId = getUserId();
		if (!userId)
			return;
		
		const {users: [user]} = await api.put("users", {
			users: [userId],
			modifications: {contacts}
		});
		
		if (user)
			dispatcher.dispatch("updateUser", user);
	} catch (error) {
		if ("id" in error && (!error.group || error.group != "REQUEST_ERROR"))
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
}


// WEBPACK FOOTER //
// ./src/api/saveContacts.js